import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColorsDashboardPage } from "@ryde/theme";

export const NotificationItemHeaderStyled = styled.header.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "notification-item-header-styled",
  },
)`
  display: flex;
  gap: 10px;
  align-items: flex-start;

  .NotificationItemHeader-Title {
    color: ${greyMui._900};
    font-size: 14px;
    flex-grow: 1;
    /* An unbroken string (e.g. an untranslated key) would otherwise run past the card on a phone. */
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .NotificationItemHeader-Time {
    color: ${rydeColorsDashboardPage.greyTextNumeric};
  }
`;
